<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import {getToken, getUserInfo} from "@/utils/sessionUtils";
import {$addRouters} from "@/router";

export default {
  name: 'App',
  components: {},
  props: {},
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {
    // this.$router.push('/debug')
    // 这段代码是用来缓存刷新前的router路径，但是会把url后面的参数清除！！！需要修复
    // const _this = this
    // let path = sessionStorage.getItem("pathName")
    // sessionStorage.removeItem("pathName")
    // if (!!path) {
    //   _this.$router.push({path: path})
    // }
    //
    // window.addEventListener("beforeunload", () => {
    //   sessionStorage.setItem("pathName", window.location)
    // })
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style>
#app {
  margin: 0;
  padding: 0;
}
</style>
